import { render } from "./Tips.vue?vue&type=template&id=47ba9972&scoped=true&ts=true"
import script from "./Tips.vue?vue&type=script&lang=ts"
export * from "./Tips.vue?vue&type=script&lang=ts"

import "./Tips.vue?vue&type=style&index=0&id=47ba9972&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ba9972"]])

export default __exports__